import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "search-bar-with-regle" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  class: "label",
  for: "site-filter"
}
const _hoisted_4 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        id: "site-filter",
        class: "site-input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event)),
        type: "text",
        placeholder: " ",
        required: ""
      }, null, 512), [
        [_vModelText, _ctx.filter]
      ]),
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('siteSelection.searchBar.placeHolder')), 1),
      (_ctx.filter)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "icon",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args))),
            src: _ctx.clearIcon,
            alt: _ctx.$t('alt.effacer.recherche')
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ReglePastille, { cle: "demandeIntervention.rechercheSiteCritere" })
  ]))
}